import { l, lc } from '@js/utils/toolbox';
import checktick from '@/assets/images/global/checkbox.svg?raw';

function priceWatcherFlash (id, sortedColumn, inEditMode) {
	if (sortedColumn) {
		return '';
	} else if (id === inEditMode) {
		return 'pricewatcher-table__flashed';
	}
	return '';
}

export function priceWatcherGenerateTable (items, sortedColumn, isEditMode, isLoggedIn) {
	if (items === false) {
		return '';
	}
	if (!isLoggedIn) {
		return `
<div class="data-price-hunter-login" data-price-hunter-login>
	<div>${l('pricewatcher.login_required')}</div>
	<button data-action="open-pricewatcher-login-modal" class="abBtn abBtn--whiteBlue">${l('pricewatcher.login')}</button>
		`;
	}

	let html = `<div id="pricewatcher-table" class="fakeTable pricewatcher-table">
<div class="fakeTable--headerRow abTabNav abTabNav--priceAlertList">
	<div class="fakeTable--item fakeTable--item-short abTabNav__btn  hidden xl:flex">
		<span class="abTabNav__text">${l('pricewatcher.active')}</span>
	</div>
	<div class="fakeTable--item abTabNav__btn" data-bound="from">
		<span class="abTabNav__text">${l('pricewatcher.from')}</span>
	</div>
	<div class="fakeTable--item abTabNav__btn" data-bound="to">
		<span class="abTabNav__text">${l('pricewatcher.to')}</span>
	</div>
	<div class="fakeTable--item abTabNav__btn">
		<span class="abTabNav__text">${l('pricewatcher.max_price')}</span>
	</div>
	<div class="fakeTable--item fakeTable--item-short abTabNav__btn  hidden xl:flex">
		<span class="abTabNav__text">${l('pricewatcher.adults')}</span>
	</div>
	<div class="fakeTable--item fakeTable--item-short abTabNav__btn  hidden xl:flex">
		<span class="abTabNav__text">${l('pricewatcher.children')}</span>
	</div>
	<div class="fakeTable--item fakeTable--item-short abTabNav__btn  hidden xl:flex">
		<span class="abTabNav__text">${l('global.simplePhrases.infants').charAt(0).toUpperCase() + l('global.simplePhrases.infants').slice(1)}</span>
	</div>
	<div class="fakeTable--item abTabNav__btn hidden lg:flex">
		<span class="abTabNav__text">${l('pricewatcher.date_span')}</span>
	</div>
	<div class="fakeTable--item fakeTable--item-short abTabNav__btn hidden lg:flex">
		<span class="abTabNav__text">${l('pricewatcher.trip_length')}</span>
	</div>
	<div class="fakeTable--item fakeTable--item-short abTabNav__btn  hidden xl:flex">
		<span class="abTabNav__text">${l('pricewatcher.direct_flight')}</span>
	</div>
	<div class="fakeTable--item fakeTable--item-short abTabNav__btn  hidden xl:flex">
		<span class="abTabNav__text">${l('pricewatcher.weekend')}</span>
	</div>
	<div class="fakeTable--item fakeTable--item-short abTabNav__btn ">
		<span class="abTabNav__text">${l('pricewatcher.update')}</span>
	</div>
</div>
<ul id="existing-entries" class="fakeTable--content">`;

	html += items.map(item => `
<li data-id="${item.id}" class="fakeTable--row ${priceWatcherFlash(item.id, sortedColumn, isEditMode)}" data-active="${item.active}">
	<div class="fakeTable--item fakeTable--item-short hidden md:flex">
		<label for="${item.id}" class="checkbox" tabindex="0">
			${item.active
				? `<input id="${item.id}" type="checkbox" class="toggle-checkboxes" checked="checked">`
				: `<input id="${item.id}" type="checkbox" class="toggle-checkboxes">`
			}
			<div class="checkbox__tick">
				<div class="checkbox__tick--svg">${checktick}</div>
				<span></span>
			</div>
		</label>
	</div>
	<div class="fakeTable--item">
		<span>${item.city_from_text}</span>
	</div>
	<div class="fakeTable--item">
		<span>${item.city_to_text}</span>
	</div>
	<div class="fakeTable--item">
		<span class="price">${lc(item.price)}</span>
	</div>
	<div class="fakeTable--item fakeTable--item-short hidden xl:flex">
		${item.adults}
	</div>
	<div class="fakeTable--item fakeTable--item-short hidden xl:flex">
		${item.children ? item.children : '-'}
	</div>
	<div class="fakeTable--item fakeTable--item-short hidden xl:flex">
		${item.infants ? item.infants : '-'}
	</div>
	<div class="fakeTable--item hidden lg:flex">
		${item.date_from ? (item.date_to ? `${item.date_from} - ${item.date_to}` : item.date_from) : '-'}
	</div>
	<div class="fakeTable--item fakeTable--item-short hidden lg:flex">
		${item.date_diff_min ? (item.date_diff_max ? `${item.date_diff_min} - ${item.date_diff_max}` : item.date_diff_min) : '-'}
	</div>
	<div class="fakeTable--item fakeTable--item-short hidden xl:flex">
		<span>${item.direct_flight_only ? `${l('global.simplePhrases.Yes')}` : `${l('global.simplePhrases.No')}`}</span>
	</div>
	<div class="fakeTable--item fakeTable--item-short hidden xl:flex">
		<span>${item.weekend_only ? `${l('global.simplePhrases.Yes')}` : `${l('global.simplePhrases.No')}`}</span>
	</div>
	<div class="fakeTable--item fakeTable--item-short pricewatcher-table__item-tools">
		<button title="${l('pricewatcher.update_trip')}" class="circleBtn" data-action="update-pricewatcher">
			<i class="icon-pencil"></i>
		</button>
		<button title="${l('pricewatcher.delete_trip')}" class="circleBtn" data-action="delete-pricewatcher">
			<i class="icon-cross"></i>
		</button>
	</div>
</li>`)
		.join('');

	html += '</ul></div>';

	return html;
}
